// mips-gauges.component.ts
import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef, Input, Output, EventEmitter } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { GaugeData } from '@models/gauges.model';
import { NgxGaugeModule } from 'ngx-gauge';



@Component({
  selector: 'app-mips-gauges',
  imports: [MatCardModule, CommonModule, NgxGaugeModule, MatTooltipModule, MatSlideToggleModule, MatIconModule],
  templateUrl: './mips-gauges.component.html',
  styleUrls: ['./mips-gauges.component.css']
})
export class MipsGaugesComponent implements OnInit, AfterViewInit {
  @ViewChildren('gaugeChart') chartElements!: QueryList<ElementRef>;
  @Input() gauges: GaugeData[] = [];
  @Output() reweightToggle = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  onToggleReweight(gauge: GaugeData): void {
    this.reweightToggle.emit(gauge.id);
  }

  getMarker(gauge: GaugeData): any {
    if (gauge.max === 0) return {};
    return {
      [gauge.min]: {
        color: "#555",
        type: "line",
        size: 12,
        label: gauge.min,
        font: "12px arial"
      },
      [gauge.max]: {
        color: "#555",
        type: "line",
        size: 12,
        label: gauge.max,
        font: "12px arial"
      },
    };
  }

  getTooltipText(gauge: GaugeData): string {
    return gauge.tooltip?.replace(/<br>/g, '\n') || '';
  }
}